<template>
  <div :class="['search-container', { 'sticky': isSticky }]">
    <div class="search-warpper">
      <div class="search-input-wrapper">
        <el-input ref="ignoreElRef" class="search-input" v-model="inputVal"
          :placeholder="$t('search.searchPlaceholder')" @focus="handleInputFocus" @input="handleInputing"
          @blur="handleInputBlur" @keyup.enter="handleInputEnter()" @click="searchInputClick">
          <template #prefix>
            <icon-search :class="['icon-search', { 'is-focus': inputVal }]" @click="handleInputEnter()" />
          </template>
        </el-input>

        <div v-show="dropdown" class="input-tool" v-on-click-outside="onClickOutsideHandler">
          <!-- 历史记录 -->
          <div v-if="historyList.length" class="history-container">
            <el-row justify="space-between" align="middle">
              <div class="title">
                {{ $t('home.recentSearch') }}
              </div>
              <div class="action" @click="handleHistoryClear">
                {{ $t('home.clear') }}
              </div>
            </el-row>
            <el-space class="search-card-warpper" wrap>
              <div v-for="item in historyList" :key="item">
                <div class="search-card" @click="handleClickSearchText(item)">
                  <p>{{ item }}</p>
                </div>
              </div>
            </el-space>
          </div>

          <!-- 趋势 -->
          <div class="trends-container">
            <el-row justify="space-between" align="middle">
              <div class="title">
                {{ $t('home.trendsSearch') }}
              </div>
              <div class="action">
                <NuxtLinkLocale to="/images-photos/hot">
                  <icon-trends />
                  <span>{{ $t('home.details') }}</span>
                </NuxtLinkLocale>
              </div>
            </el-row>
            <el-space class="search-card-warpper" wrap key="search-tool">
              <div v-for="item in trendsList?.page" :key="item.ctime">
                <div class="search-card" @click="handleClickSearchText(item.searchName)">
                  <icon-trends class="trends-icon" />
                  <p>{{ item.searchName }}</p>
                </div>
              </div>
            </el-space>
          </div>

        </div>
      </div>

      <div v-if="showTag && categoryList?.page.length" class="scroll-tag-warpper">
        <ScrollableView :background="isSticky && width > 800 && isClient ? '#fff' : '#F4F5F6'"
          :rlWidth="isSticky ? 50 : 100" :showArrowMask="false">
          <NuxtLinkLocale class="tag" v-for="item in categoryList.page" :key="item"
            :to="`/images-photos/pictures/${picTitleToHyphen(item.categoryName)}`"
            @click="handleTagClick(item.categoryName)">
            {{ item.categoryName }}
          </NuxtLinkLocale>
        </ScrollableView>
      </div>
    </div>
  </div>
</template>

<script setup>
import { vOnClickOutside } from '@vueuse/components'
const router = useRouter()
const route = useRoute()
const { $analytic } = useNuxtApp();
const localePath = useLocalePath()
const { t, locale } = useI18n();
const isClient = ref(false)
const { sticky, offset, showTag } = defineProps({
  sticky: {
    required: false,
    default: true,
  },
  offset: {
    required: false,
    default: 40,
  },
  showTag: {
    required: false,
    default: true,
  },
  trendsList: [],
  categoryList: []
});

const { y } = useWindowScroll()
const { width, height } = useWindowSize()
// pc端初始高度不会触发sticky行为，可以根据滚动去判断。
// 由于ssr不能获取到屏幕宽/高度，手机端默认sticky，但却只能挂载时去计算，所以需要写两套html结构
const isSticky = computed(() => {
  return sticky && (offset === 0 || y.value > offset)
})

const handleTagClick = (tag) => {
  setHistory(tag)
  handleInputEnter(tag.categoryName)
}

const inputVal = ref(picTitleToWhitespace(route.params?.keyword))
const dropdown = ref(false);
const focusFlag = ref(false)
const responseScroll = ref(false);

const handleInputFocus = () => {
  focusFlag.value = true
  if (!inputVal.value) {
    dropdown.value = true;
  }
  setTimeout(() => {
    responseScroll.value = true
  }, 300)
}
const handleInputBlur = () => {
  focusFlag.value = false
  responseScroll.value = true
}


const handleInputing = () => {
  dropdown.value = !inputVal.value
}

const ignoreElRef = ref()
const onClickOutsideHandler = [
  (ev) => {
    dropdown.value = false
  },
  { ignore: [ignoreElRef] },
]

const { getHistory, setHistory, clearHistory } = useSearchHistory()
const historyList = ref([])
const handleInputEnter = (val) => {
  const _val = (val || inputVal.value).trim();
  if (_val) {
    handleSearch(_val)
    historyList.value = setHistory(_val)
  }
}

const handleSearch = (val) => {
  dropdown.value = false

  const path = localePath({
    name: routesName.search,
    params: { keyword: picTitleToHyphen(val) }
  })
  router.push(path);
}

const handleClickSearchText = (val) => {
  setHistory(val)
  inputVal.value = val
  handleInputEnter()
}

const handleHistoryClear = () => {
  clearHistory()
  historyList.value = []
}

const searchInputClick = () => {
  $analytic.log('gallery_search_tick');
}

onMounted(() => {
  isClient.value = true
  historyList.value = getHistory()

  if (import.meta.client) {
    window.document.addEventListener("scroll", (event) => {
      if (!responseScroll.value) return
      handleScroll()
    });
  }
})

function handleScroll() {
  if (ignoreElRef) {
    responseScroll.value = false
    ignoreElRef.value?.blur()
    dropdown.value = false;
  }
}

</script>

<style lang="scss" scoped>
@import url(./pc.scss);
@import url(./h5.scss);
</style>

<style lang="scss">
.search-input-wrapper {
  .el-input.search-input {
    --el-input-text-color: #000;
    --el-input-text-placeholder: $font-aux-cl;
    --el-input-border-color: none;
    --el-input-hover-border-color: none;
    --el-input-focus-border-color: none;

    .el-input__wrapper {
      // padding-left: 0;
    }

    .el-input__prefix {
      .icon-search {
        margin-left: 9px;
        margin-right: 18px;
        height: 16px;
        width: 16px;
        color: $font-aux-clo;
        cursor: pointer;

        &.is-focus {
          color: #303131;
        }
      }
    }
  }

  @include responseTo(pc-800px) {
    .el-input__wrapper {
      font-size: 18px;
      background-color: #fff;
    }
  }

  @include responseTo(web-799px) {
    .el-input__wrapper {
      font-size: 16px;
    }
  }
}

.search-container.sticky {
  .el-input__wrapper {
    background-color: $main-input-back-clo;

    @include responseTo(web-799px) {
      background-color: #fff;
    }
  }
}
</style>
